import { render, staticRenderFns } from "./event-edit.vue?vue&type=template&id=2aa11de5&"
import script from "./event-edit.vue?vue&type=script&lang=ts&"
export * from "./event-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports